export enum bsUploadType {
    PDF = "PDF",
    NET_BANKING = "NET_BANKING",
}

export enum bsVendor {
    FINBOX = "FINBOX",
}

export enum RequestPath {
    START = "start",
    UPLOAD = "upload",
    COMPLETE = "complete",
}
